import Container from "@/src/components/Container/Container";
import Grid from "@mui/material/Grid";
import ChipLegalbird from "@/src/components/legalbird/ChipLegalbird/ChipLegalbird";
import Typography from "@mui/material/Typography";
import AccordionGroupProvider from "@/src/components/Accordion/AccordionGroupProvider";
import { Stack } from "@mui/material";
import AreaOfLawAccordion from "@/src/components/AreaOfLawAccordion/AreaOfLawAccordion";
import Section from "@/src/components/Section/Section";
import { areasOfLawAccordionContent } from "@/src/components/AreaOfLawAccordion/areasOfLawAccordionContent";

const AreasOfLaw = () => {
  return (
    <Section>
      <Container variant={"md"}>
        <Grid container sx={{ justifyContent: "space-between" }}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <ChipLegalbird label="Rechtsbereiche" />
            <Typography variant={"h3"}>Bei diesen Themen helfen wir gerne weiter</Typography>
            <Typography>
              Egal, welches rechtliche Problem Sie gerade beschäftigt – wir begleiten Sie persönlich und setzen uns professionell für Sie ein!
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 5 }}>
            <AccordionGroupProvider>
              <Stack spacing={2}>
                {areasOfLawAccordionContent.map((content, idx) => (
                  <AreaOfLawAccordion key={idx} {...content} />
                ))}
              </Stack>
            </AccordionGroupProvider>
          </Grid>
        </Grid>
      </Container>
    </Section>
  );
};

export default AreasOfLaw;
